import { combineReducers } from 'redux';

// Biuwer UI reducers
import dndContext from "./dnd-system/dnd-system-reducers";

export default combineReducers({
    dndContext,
});